import countries from '../../constants/countries';

export const fetchDialCode = async () => {
  const IP_INFO_TOKEN = 'a2537b705bbc26';
  try {
    const res = await fetch('https://ipinfo.io', {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${IP_INFO_TOKEN}`,
        Accept: 'Application/json',
      }),
    });
    const json = await res.json();
    const countryCode = json.country;
    const dialCode = countries.filter(c => c.code === countryCode)[0].dial_code;
    return dialCode;
  } catch (error) {
    return error;
  }
};

export default fetchDialCode;

export const conditionallyAddPlusToDialCode = (dialCodeString = '+65') => {
  if (dialCodeString[0] === '+') {
    return dialCodeString;
  }
  return `+${dialCodeString}`;
};



// WEBPACK FOOTER //
// ./app/utils/fetchDialCode/index.js